<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">{{ isRecommendationPage ? '推荐活动' : '活动列表' }}</h3>
                </div>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
    <el-form :inline="true" ref="ruleForm" :model="formInline" class="demo-form-inline">
      <template v-if="isRecommendationPage">
        <el-form-item label="活动ID">
          <el-input v-model="formInline.id" placeholder="请输入活动ID"></el-input>
        </el-form-item>
        <el-form-item label="推荐状态">
          <el-select v-model="formInline.recommend_filter" style="width: 160px">
            <el-option label="全部" value="" />
            <el-option label="已上架" value="active" />
            <el-option label="未上架" value="withdrawn" />
          </el-select>
        </el-form-item>
        <el-form-item label="推荐位置">
          <el-select v-model="formInline.recommend_placement" clearable placeholder="全部" style="width: 140px">
            <el-option label="首页" value="discovery" />
            <el-option label="活动推荐" value="result_card" />
          </el-select>
        </el-form-item>
      </template>
      <template v-else>
      <el-form-item label="用户ID">
        <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
      </el-form-item>
      <el-form-item label="活动ID">
        <el-input v-model="formInline.id" placeholder="请输入活动ID"></el-input>
      </el-form-item>
      <el-form-item label="任务类型">
        <el-select v-model="formInline.type" clearable placeholder="请选择任务类型">
          <el-option label="高级版" value="advance"></el-option>
          <el-option label="极速版-旧" value="fast"></el-option>
          <el-option label="极速版-新" value="new_fast"></el-option>
          <el-option label="群抽奖" value="wechat_group"></el-option>
          <el-option label="公众号抽奖" value="mp"></el-option>
          <el-option label="九宫格抽奖" value="nine_square_grid"></el-option>
          <el-option label="大转盘抽奖" value="turntable"></el-option>
          <el-option label="翻牌抽奖" value="card"></el-option>
          <el-option label="现场抽奖" value="live"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="活动状态">
        <el-select v-model="formInline.status" clearable placeholder="请选择活动状态">
          <el-option label="未开始" :value="0"></el-option>
          <el-option label="进行中" :value="1"></el-option>
          <el-option label="已暂停" :value="2"></el-option>
          <el-option label="已结束" :value="3"></el-option>
          <el-option label="已删除" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="推荐候选">
        <el-switch v-model="formInline.candidate_only" active-text="仅符合条件" />
      </el-form-item>
      <el-form-item label="推荐状态">
        <el-select v-model="formInline.recommend_filter" clearable placeholder="全部" style="width: 120px">
          <el-option label="已上架（含待上架）" value="active" />
          <el-option label="已撤下" value="withdrawn" />
        </el-select>
      </el-form-item>
      <el-form-item label="投放位置">
        <el-select v-model="formInline.recommend_placement" clearable placeholder="全部" style="width: 120px">
          <el-option label="首页" value="discovery" />
          <el-option label="活动推荐" value="result_card" />
        </el-select>
      </el-form-item>
      <el-form-item label="参与人数">
        <el-input-number v-model="formInline.join_count_min" style="width: 130px;" controls-position="right"
          :min="-1"></el-input-number>
        <span>-</span>
        <el-input-number v-model="formInline.join_count_max" controls-position="right" style="width: 130px;"
          :min="-1"></el-input-number>
      </el-form-item>
      <el-form-item label="访问人数">
        <el-input-number v-model="formInline.visit_count_min" style="width: 130px;" controls-position="right"
          :min="-1"></el-input-number>
        <span>-</span>
        <el-input-number v-model="formInline.visit_count_max" controls-position="right" style="width: 130px;"
          :min="-1"></el-input-number>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker type="daterange" v-model="ctime" range-separator="~" start-placeholder="开始日期"
          end-placeholder="结束日期" :shortcuts="dateShortcuts" clearable @change="onChangeDate('ctime')">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker type="daterange" v-model="etime" range-separator="~" start-placeholder="开始日期"
          end-placeholder="结束日期" :shortcuts="dateShortcuts" clearable @change="onChangeDate('etime')">
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="活动类型">
        <el-select v-model="formInline.template_type" clearable placeholder="请选择活动类型">
          <el-option v-for="item in templateOptions" :key="item.value" :value="item.value"
            :label="item.name"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="是否VIP">
        <el-switch :model-value="formInline.is_vip == 1" @change="onChangeVip"></el-switch>
      </el-form-item>
      <el-form-item label="标签筛选">
        <el-select v-model="formInline.selected_tags" multiple clearable placeholder="请选择标签" style="width: 300px;">
          <el-option-group v-for="(tagList, category) in tagsDict" :key="category" :label="category + '标签'">
            <el-option v-for="tag in tagList" :key="tag.id" :label="tag.label" :value="tag.id">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      </template>
      <el-form-item>
        <el-button type="primary" @click="onSearch()">查询</el-button>
        <el-button @click="onReset('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row v-if="!isRecommendationPage" :gutter="24" style="margin-bottom:20px">
      <el-col :span="24" class="filter-box">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            {{ current_sort.label }}<i class="fas fa-chevron-down ml-1"></i>
          </span>
          <template #dropdown><el-dropdown-menu>
            <el-dropdown-item v-for="sort_item in sort_options" :key="sort_item.value" :command="sort_item">{{
              sort_item.label
            }}</el-dropdown-item>
          </el-dropdown-menu></template>
        </el-dropdown>
        <i v-if="sort_type === -1" @click="handleChangeSort(1)" class="fas fa-sort-amount-down sort-icon"></i>
        <i v-else @click="handleChangeSort(-1)" class="fas fa-sort-amount-up sort-icon"></i>
      </el-col>
    </el-row>
    <div class="block w-full overflow-x-auto">
    <el-table v-if="isRecommendationPage" v-loading="loading" :data="tableData" border stripe
      highlight-current-row style="width: 100%; min-width: 1080px;">
      <el-table-column fixed label="活动信息" min-width="300">
        <template #default="scope">
          <div class="recommend-activity-cell">
            <img v-if="getActivityCover(scope.row)" class="recommend-activity-cover"
              :src="getActivityCover(scope.row)" alt="活动封面">
            <div>
              <div class="column-link-item" @click="toDetail(scope.row)">
                {{ getLotteryName(scope.row.name, scope.row.prize_config, scope.row.activity_topic) }}
              </div>
              <div class="recommend-meta">ID：{{ scope.row.id }}</div>
              <div class="recommend-meta">{{ scope.row.type_name }} · {{ scope.row.open_type_name }}</div>
              <div class="recommend-meta">活动结束：{{ scope.row.etime || '-' }}</div>
              <div class="recommend-meta">详情 PV：{{ recommendationPv(scope.row, 'discovery') + recommendationPv(scope.row, 'result_card') }}（首页 {{ recommendationPv(scope.row, 'discovery') }} · 活动推荐 {{ recommendationPv(scope.row, 'result_card') }}）</div>
              <div class="recommend-meta">首页接口输出 PV：{{ recommendationRecord(scope.row, 'discovery')?.output_pv || 0 }} · 页面展示 PV：{{ recommendationRecord(scope.row, 'discovery')?.render_pv || 0 }}</div>
              <div class="recommend-meta">活动推荐接口输出 PV：{{ recommendationRecord(scope.row, 'result_card')?.output_pv || 0 }} · 页面展示 PV：{{ recommendationRecord(scope.row, 'result_card')?.render_pv || 0 }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="首页" min-width="280">
        <template #default="scope">
          <div class="recommend-placement-cell">
            <el-tag :type="recommendationTagType(recommendationRecord(scope.row, 'discovery')?.display_status)" size="small">
              {{ recommendationStateLabel(recommendationRecord(scope.row, 'discovery')?.display_status) }}
            </el-tag>
            <div class="recommend-time">{{ formatRecommendationRange(recommendationRecord(scope.row, 'discovery')) }}</div>
            <div v-if="recommendationRecord(scope.row, 'discovery')" class="recommend-meta">
              排序优先级：{{ recommendationRecord(scope.row, 'discovery').priority || 0 }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="活动推荐" min-width="280">
        <template #default="scope">
          <div class="recommend-placement-cell">
            <el-tag :type="recommendationTagType(recommendationRecord(scope.row, 'result_card')?.display_status)" size="small">
              {{ recommendationStateLabel(recommendationRecord(scope.row, 'result_card')?.display_status) }}
            </el-tag>
            <div class="recommend-time">{{ formatRecommendationRange(recommendationRecord(scope.row, 'result_card')) }}</div>
            <div v-if="recommendationRecord(scope.row, 'result_card')" class="recommend-meta">
              排序优先级：{{ recommendationRecord(scope.row, 'result_card').priority || 0 }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120">
        <template #default="scope">
          <el-button @click="openRecommendation(scope.row)" size="small" type="text">推荐管理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-else v-loading="loading" :data="tableData" border stripe highlight-current-row style="width: 100%; min-width: 1800px;">
      <el-table-column fixed label="基本信息">
        <template #default="scope">
          <div class="column-item"><span>{{ scope.row.id }}</span></div>
          <div class="column-link-item" @click="toDetail(scope.row)">
            <span>{{ getLotteryName(scope.row.name, scope.row.prize_config, scope.row.activity_topic) }}</span>
          </div>
          <div class="column-item head-img-box" v-if="scope.row.head_image && scope.row.head_image.url">
            <video v-if="scope.row.head_image.type === 2" :src="scope.row.head_image.url" width="105px" autoplay
              muted></video>
            <img v-else style="width: 105px;" :src="scope.row.head_image.url" alt="">
          </div>
          <div v-else class="column-item head-img-box">
            <img v-if="getFirstPrizePic(scope.row.prize_config)" style="width: 105px;" :src="getFirstPrizePic(scope.row.prize_config)"
              alt="">
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed label="奖品信息">
        <template #default="scope">

          <div v-for="(prize_item, prize_index) in scope.row.prize_config && scope.row.prize_config.prizes"
            :key="prize_index">
            <span>{{prize_item.label}}:</span>
            <span>{{ prize_item.name }}</span>
            <span style="color: #67c23a;">{{ getPrizeDetail(prize_item) }}</span>
            <span>x{{ prize_item.count }}&nbsp;&nbsp;</span>
            <span v-if="prize_item.hide_condition">隐藏不可开出条件</span>
            <span v-if="prize_item.limit_count >= 50">X人参与前不可开出</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed label="活动说明">
        <template #default="scope">
          <div class="column-item" v-if="scope.row.content">
            <div v-html="scope.row.content"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed label="活动信息" min-width="100">
        <template #default="scope">
          <div class="column-item avatar-box" v-if="scope.row.ex_user && scope.row.ex_user.name">
            <span>企微好友：</span>
            <img style="width:24px" :src="scope.row.ex_user.ex_rs" alt="">
            <span>{{ scope.row.ex_user.name }}</span>
          </div>
          <div class="column-item" v-if="scope.row.follow_user">
            <span>跟进人：</span>
            <span>{{ scope.row.follow_user }}</span>
          </div>
          <div class="column-item">
            <span>用户ID：</span>
            <span class="user-id-link" @click="handleUserClick(scope.row.uid)">{{ scope.row.user_id }}</span>
          </div>
          <div class="column-item">
            <span>电话：</span>
            <span>{{ scope.row.mobile }}</span>
          </div>
          <div class="column-item">
            <span>unionid:</span>
            <span>{{ scope.row.unionid }}</span>
          </div>
          <div class="column-item">
            <span>uid:</span>
            <span>{{ scope.row.uid }}</span>
          </div>
          <div class="column-item">
            <span>活动类型：</span>
            <span>{{ scope.row.type_name }}</span>
          </div>
          <div class="column-item" v-if="scope.row.type !== 'live'">
            <span>开奖方式：</span>
            <span>{{ scope.row.open_type_name }}</span>
          </div>
          <div class="column-item" v-if="scope.row.type == 'live'">
            <span>参与方式：</span>
            <span>{{ scope.row.open_type_name }}</span>
          </div>
          <div class="column-item">
            <span>创建终端：</span>
            <span>{{ scope.row.create_source }}</span>
          </div>
          <div class="column-item">
            <span>创建时间：</span>
            <span>{{ scope.row.ctime }}</span>
          </div>
          <div class="column-item" v-if="scope.row.etime">
            <span>结束时间：</span>
            <span>{{ scope.row.etime }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed label="已修改设置">
        <template #default="scope">
          <div class="column-item" v-if="scope.row.channel_name">
            <span>公众号：</span>
            <span>{{ scope.row.channel_name }}</span>
          </div>

          <div class="column-item" v-if="scope.row.join_config && scope.row.join_config.need_scan">
            <span>扫码后可参与</span>
          </div>

          <div class="column-item" v-if="scope.row.mp_config && scope.row.mp_config.is_open">
            <span>公众号粉丝参与</span>
          </div>

          <div class="column-item" v-if="scope.row.join_config && scope.row.join_config.need_passcode">
            <span>输入口令参与</span>
          </div>

          <div class="column-item" v-if="scope.row.join_config && scope.row.join_config.only_group_member === 1">
            <span>仅群成员参与</span>
          </div>

          <div class="column-item"
            v-if="scope.row.join_config && scope.row.join_config.only_friend_config && scope.row.join_config.only_friend_config.is_open">
            <span>添加微信参与</span>
          </div>

          <div class="column-item"
            v-if="scope.row.join_config && scope.row.join_config.wework_add_friend_config && scope.row.join_config.wework_add_friend_config.is_open">
            <span>添加企微参与</span>
          </div>

          <div class="column-item" v-if="scope.row.join_config && scope.row.join_config.need_voucher">
            <span>上传凭证参与</span>
          </div>

          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.join_count_limit > 1000">
            <span>参与人数: {{ scope.row.rule_config.join_count_limit }}</span>
          </div>

          <div class="column-item" v-if="scope.row.join_config && scope.row.join_config.need_form">
            <span>填写信息参与</span>
          </div>

          <div class="column-item" v-if="scope.row.location_limit_config && scope.row.location_limit_config.is_open">
            <span>限制区域参与</span>
          </div>

          <div class="column-item" v-if="scope.row.help_config && scope.row.help_config.allow_invite">
            <span>邀请好友助力</span>
          </div>

          <div class="column-item" v-if="scope.row.help_config && scope.row.help_config.add_group">
            <span>进群助力任务</span>
          </div>

          <div class="column-item" v-if="scope.row.help_config && scope.row.help_config.add_friend">
            <span>加好友助力任务</span>
          </div>

          <div class="column-item" v-if="scope.row.no_login_config && scope.row.no_login_config.is_open">
            <span>新用户免登录</span>
          </div>

          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.deter_risk_user">
            <span>识别高风险用户</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.hide_join_count">
            <span>隐藏参与人数</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.hide_prize_percent">
            <span>隐藏中奖率</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.hide_prize_win_count">
            <span>隐藏领取份数</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.hide_winner_list">
            <span>隐藏中奖名单</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.hide_prize_label">
            <span>隐藏奖项名称</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.hide_prize_count">
            <span>隐藏奖品总数</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.type === 2  &&  scope.row.rule_config.open_type === 2">
            <span>满人-不开奖</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.no_forward">
            <span>禁止参与人分享</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.can_quit">
            <span>允许参与人退出</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.win_limit === 1">
            <span>每个奖项可以中一次</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.win_limit === 2">
            <span>本次活动可以中一次</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.award_method === 2">
            <span>单独设置领奖方式</span>
          </div>
          <div class="column-item"
            v-if="scope.row.rule_config && scope.row.rule_config.award_expire_info && scope.row.rule_config.award_expire_info.type === 1 && scope.row.rule_config.award_expire_info.days !== 7">
            <span>修改领奖时间：</span>
            <span>{{ scope.row.rule_config.award_expire_info.days }} 天</span>
          </div>
          <div class="column-item"
            v-if="scope.row.rule_config && scope.row.rule_config.award_expire_info && scope.row.rule_config.award_expire_info.type === 2">
            <span>修改领奖时间：</span>
            <span>{{ new Date(scope.row.rule_config.award_expire_info.deadline * 1000).toLocaleDateString() }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed label="标签">
        <template #default="scope">
          <div class="column-item" v-for="tagInfo in getDisplayTags(scope.row.tags)" :key="tagInfo.id">
            <el-tag :type="getTagType(tagInfo.category)" size="small">{{ tagInfo.label }}</el-tag>
          </div>
          <div class="column-item">
            <el-button size="small" type="text" @click="handleTagActivity(scope.row)">打标</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed label="活动数据">
        <template #default="scope">
          <div class="column-item" v-if="scope.row.is_vip">
            <span>付费状态：</span>
            <span style="color:#67c23a;">已付费</span>
          </div>
          <div class="column-item" v-if="scope.row.openapi_trial_expire">
            <span>接口试用：</span>
            <span :style="{ color: isTrialActive(scope.row.openapi_trial_expire) ? '#67c23a' : '#909399' }">
              {{ isTrialActive(scope.row.openapi_trial_expire) ? '有效至' : '已到期' }}
              {{ formatTimestamp(scope.row.openapi_trial_expire) }}
            </span>
          </div>
          <div class="column-item">
            <span>活动状态：</span>
            <span v-if="scope.row.status == 1" style="color:#67c23a;">{{ statusOption[scope.row.status] }}</span>
            <span v-else-if="scope.row.status == 3" style="color:#f78989;">{{ statusOption[scope.row.status] }}</span>
            <span v-else>{{ statusOption[scope.row.status] }}</span>
          </div>
          <div class="column-item"><span>允许平台推荐：</span>{{ scope.row.enable_pub === 1 ? '是' : '否' }}</div>
          <div class="column-item" v-for="(state, placement) in scope.row.recommend_states" :key="placement">
            <span>{{ placement === 'discovery' ? '首页' : '活动推荐' }}：</span>{{ recommendationStateLabel(state) }}
          </div>
          <div class="column-item">
            <span>访问人数：</span>
            <span>{{ scope.row.visit_count }}</span>
          </div>
          <div class="column-item" v-if="scope.row.rule_config && scope.row.rule_config.type === 2">
            <span>开奖人数：</span>
            <span>{{ scope.row.rule_config.people_count }}</span>
          </div>
          <div class="column-item">
            <span>参与人数：</span>
            <span>{{ scope.row.join_count }}</span>
          </div>
          <div class="column-item">
            <span>新参与人数：</span>
            <span>{{ scope.row.new_join_count }}</span>
          </div>
          <div class="column-item">
            <span>获奖人数：</span>
            <span>{{ scope.row.winner_count }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" min-width="150">
        <template #default="scope">
          <el-button @click="openRecommendation(scope.row)" size="small" type="text">推荐管理</el-button>
          <el-button @click="setTaskBanned(scope.row.id)" :disabled="scope.row.is_banned" size="small" type="text">封禁任务
          </el-button>
          <el-button v-if="!scope.row.is_template" @click="handleTemplate(scope.row)" size="small"
            type="text">上架为模板</el-button>
          <el-button v-else @click="handleTemplate(scope.row)" size="small" type="text">下架模板</el-button>
          <el-button v-if="canGrantActivityTrial" @click="grantActivityTrial(scope.row)"
            :loading="trialGrantingId === scope.row.id" size="small" type="text">
            {{ isTrialActive(scope.row.openapi_trial_expire) ? '续期接口试用' : '授权接口试用' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <el-pagination style="margin-top: 16px; text-align: right" background
      layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[20, 50, 100]"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-size="pageSize">
    </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="currentItem.name" v-model="dialogVisible" width="30%" :before-close="handleClose">
      <div class="prize-box">
        <div>
          <div v-if="currentItem.head_image && currentItem.head_image.url">
            <video v-if="currentItem.head_image.type === 2" :src="currentItem.head_image.url" width="105px" autoplay
              muted></video>
            <img v-else style="width: 105px;" :src="currentItem.head_image.url" alt="">
          </div>
          <div v-for="(prize_item, prize_index) in currentItem.prize_config && currentItem.prize_config.prizes"
            :key="prize_index" class="prize-name">
            <span>奖品：</span>
            <span>{{ prize_item.name }}</span>
            <span>x{{ prize_item.count }}</span>
          </div>
          <div class="prize-time">
            <span>{{ currentItem.etime }}</span>
            <span>{{ currentItem.open_type_name }}</span>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="运营精选推荐" v-model="recommendVisible" width="640px">
      <div v-loading="recommendLoading">
        <div v-if="recommendActivity.id" style="display: flex; gap: 12px; margin-bottom: 12px">
          <img v-if="recommendActivity.head_image?.url" :src="recommendActivity.head_image.url" alt="活动封面" style="width: 96px; height: 96px; object-fit: cover" />
          <div>
            <div>{{ recommendActivity.name }}（{{ recommendActivity.id }}）</div>
            <div>开奖方式：{{ recommendActivity.open_type_name }}；结束：{{ recommendActivity.etime }}</div>
            <div>奖品：{{ (recommendActivity.prize_config?.prizes || []).map(item => item.name).join('、') }}</div>
          </div>
        </div>
        <el-alert v-if="recommendCandidateError" :title="recommendCandidateError" type="warning" :closable="false" style="margin-bottom: 12px" />
        <el-tabs v-model="recommendPlacement" @tab-change="selectRecommendationPlacement">
          <el-tab-pane label="首页" name="discovery" />
          <el-tab-pane label="活动推荐" name="result_card" />
        </el-tabs>
        <el-form label-width="100px">
          <el-form-item label="当前状态">{{ recommendationStateLabel(currentRecommendation?.display_status) }}</el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker v-model="recommendForm.start_at" type="datetime" placeholder="选择开始时间" style="width: 100%" />
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="recommendForm.end_at" type="datetime" placeholder="不得晚于活动结束时间" style="width: 100%" />
          </el-form-item>
          <el-form-item label="排序优先级">
            <el-input-number v-model="recommendForm.priority" :min="0" :max="1000" />
          </el-form-item>
          <el-form-item label="审核备注">
            <el-input v-model="recommendForm.review_note" type="textarea" :rows="2" maxlength="500" show-word-limit />
          </el-form-item>
        </el-form>
        <div v-if="recommendLogs.length" style="margin-top: 16px">
          <strong>最近操作记录</strong>
          <div v-for="log in recommendLogs" :key="log._id" style="font-size: 12px; margin-top: 6px">
            {{ formatTimestamp(log.time) }} · {{ log.operator }} · {{ log.action === 'withdraw' ? '撤下' : '上架/修改' }}
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="recommendVisible = false">关闭</el-button>
        <el-button v-if="currentRecommendation && currentRecommendation.status === 'active'"
          type="danger" plain :loading="recommendSaving" @click="saveRecommendation('withdraw')">撤下</el-button>
        <el-button type="primary" :disabled="recommendLoading || !!recommendCandidateError"
          :loading="recommendSaving" @click="saveRecommendation('save')">审核并上架</el-button>
      </template>
    </el-dialog>
    <el-dialog title="二维码" v-model="dialogQrcodeVisible" width="30%" :before-close="handleQrcodeClose">
      <div style="text-align: center;">
        <img :src="previewImage" style="width:300px;height:300px;" alt="">
      </div>
    </el-dialog>

    <el-dialog title="上架模板" :close-on-click-modal="false" v-model="templateVisible" width="460px">
      <el-form :model="templateData" :rules="template_rules" ref='template_form' label-width="110px">
        <el-form-item label="选择模版类型" prop="type">
          <el-select class="form_value" v-model="templateData.type" placeholder="请选择">
            <el-option v-for="item in templateOptions" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板标题" prop="template_title">
          <el-input v-model="templateData.template_title" name="template_title"></el-input>
        </el-form-item>
        <el-form-item label="模板图片">
          <el-upload name="file" class="avatar-uploader" :action="uploadImgUrl" :headers="uploadHeaders" :data="upload_data"
            :show-file-list="false" :on-success="handleImgSuccess" :before-upload="beforeImgUpload">
            <img v-if="templateData.template_img" :src="templateData.template_img" class="avatar">
            <i v-else class="fas fa-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="templateVisible = false">取消</el-button>
          <el-button type="primary" @click="saveTemplate()">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 打标弹窗 -->
    <el-dialog title="活动打标" v-model="tagDialogVisible" width="500px">
      <div>
        <p style="margin-bottom: 16px;">活动ID: {{ currentActivity.id }}</p>
        <div v-for="(tagList, category) in tagsDict" :key="category" style="margin-bottom: 16px;">
          <div style="font-weight: bold; margin-bottom: 8px;">{{ category }}标签:</div>
          <el-checkbox-group v-model="selectedTags">
            <el-checkbox v-for="tag in tagList" :key="tag.id" :label="tag.id">{{ tag.label }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="tagDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveTags">保存</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 用户信息弹窗 -->
    <el-dialog title="用户信息" v-model="userDialogVisible" width="500px" :before-close="handleUserDialogClose">
      <div v-loading="userLoading">
        <div v-if="currentUserInfo.user_id" class="user-info-box">
          <div class="info-item">
            <span class="label">用户ID：</span>
            <span class="value">{{ currentUserInfo.user_id }}</span>
          </div>
          <div class="info-item">
            <span class="label">注册时间</span>
            <span class="value">{{ currentUserInfo.t_reg}}</span>
          </div>
          <div class="info-item">
            <span class="label">最近登录时间：</span>
            <span class="value">{{ formatTimestamp(currentUserInfo.last_login_time) || '暂无' }}</span>
          </div>
          <div class="info-item">
            <span class="label">创建活动数量：</span>
            <span class="value">{{ currentUserInfo.total_task_count || 0 }}</span>
          </div>
          <div class="info-item">
            <span class="label">7 天内创建活动数量：</span>
            <span class="value">{{ currentUserInfo.total_task_count_7d || 0 }}</span>
          </div>
        </div>
        <div v-else-if="!userLoading" class="no-data">
          暂无用户信息
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleUserDialogClose">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth.js';
import { MENU_PERMISSION_KEYS, canEdit } from '@/utils/rbac.js';
import { isTestAdminApiEnabled, luckdrawApi } from '@/api/luckdraw.js';

const RECOMMENDATION_ROUTE = '/admin/activities/recommendations';

function createActivityFilters(recommendationsOnly = false) {
  return {
    user_id: '',
    id: '',
    type: '',
    status: '',
    candidate_only: false,
    recommend_only: recommendationsOnly,
    recommend_filter: '',
    recommend_placement: '',
    join_count_min: -1,
    join_count_max: -1,
    visit_count_min: -1,
    visit_count_max: -1,
    ctime: { start: '', end: '' },
    etime: { start: '', end: '' },
    sort: { name: 'ctime', sort: -1 },
    template_type: '',
    is_vip: 0,
    selected_tags: [],
  };
}

export default {
  computed: {
    isRecommendationPage() {
      return this.$route.path === RECOMMENDATION_ROUTE;
    },
    canGrantActivityTrial() {
      return canEdit(getUserInfo(), MENU_PERMISSION_KEYS.CUSTOMERS_ACTIVITIES);
    },
    currentRecommendation() {
      return this.recommendRecords.find(item => item.placement === this.recommendPlacement);
    },
    recommendLogs() {
      return this.recommendAllLogs.filter(item => item.placement === this.recommendPlacement);
    },
  },
  data() {
    return {
      ctime: [],
      etime: [],
      formInline: createActivityFilters(this.$route.path === RECOMMENDATION_ROUTE),
      dateShortcuts: [
        {
          text: '最近一周',
          value: () => {
            const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1000);
            const start = new Date(new Date().toLocaleDateString());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          },
        },
        {
          text: '最近一个月',
          value: () => {
            const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1000);
            const start = new Date(new Date().toLocaleDateString());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          },
        },
        {
          text: '最近三个月',
          value: () => {
            const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1000);
            const start = new Date(new Date().toLocaleDateString());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          },
        },
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      loading: false,
      currentItem: {},
      dialogVisible: false,
      dialogQrcodeVisible: false,
      previewImage: '',
      sort_type: -1,
      current_sort: {
        label: '创建时间',
        value: 'ctime',
      },
      sort_options: [
        {
          label: '创建时间',
          value: 'ctime',
        },
        {
          label: '结束时间',
          value: 'etime',
        },
        {
          label: '参与人数',
          value: 'join_count',
        },
        {
          label: '访问人数',
          value: 'visit_count',
        },
        {
          label: '新参与人数',
          value: 'new_join_count',
        },
        {
          label: '获奖人数',
          value: 'winner_count',
        },
      ],
      statusOption: ['未开始', '进行中', '已暂停', '已结束', '已删除'],
      templateVisible: false,
      templateOptions: [
        { name: '微信群抽奖', value: 'wechat_group' },
        { name: '实体店抽奖', value: 'store' },
        { name: '公众号抽奖', value: 'mp' },
        { name: '视频号抽奖', value: 'wechat_video' },
        { name: '个人号抽奖', value: 'wechat' },
        { name: '小程序抽奖', value: 'xcx' },
      ],
      template_rules: {
        type: [
          { required: true, message: '模版类型不能为空！', trigger: 'change' },
        ],
      },
      templateData: {
        type: '',
      },
      info: null,
      uploadImgUrl: this.$uploadImageUrl,
      uploadHeaders: this.$getUploadHeaders(),
      upload_data: { biz: 'console' },
      // 标签相关数据
      tagsDict: {}, // 存储标签字典
      tagDialogVisible: false, // 打标弹窗显示
      currentActivity: {}, // 当前操作的活动
      selectedTags: [], // 已选中的标签
      trialGrantingId: '',
      // 用户信息弹窗相关数据
      userDialogVisible: false, // 用户信息弹窗显示
      currentUserInfo: {}, // 当前用户信息
      userLoading: false, // 用户信息加载状态
      recommendVisible: false,
      recommendLoading: false,
      recommendSaving: false,
      recommendActivity: {},
      recommendPlacement: 'discovery',
      recommendCandidateError: '',
      recommendRecords: [],
      recommendAllLogs: [],
      recommendForm: { start_at: null, end_at: null, priority: 0, review_note: '' }
    };
  },
  mounted() {
    // let x = localStorage.congxin_admin_token;//
    // x = x.substr(1, x.length - 2);
    // this.uploadImgUrl += x;
    //
    this.queryData();
  },
  watch: {
    '$route.path'(path, previousPath) {
      const isRecommendationPage = path === RECOMMENDATION_ROUTE;
      const wasRecommendationPage = previousPath === RECOMMENDATION_ROUTE;
      if (isRecommendationPage !== wasRecommendationPage) {
        this.resetActivityQuery();
      }
    },
  },
  methods: {
    recommendationStateLabel(state) {
      return ({ active: '展示中', scheduled: '待上架', withdrawn: '已撤下',
        review_required: '待复核', expired: '已到期' })[state] || '未上架';
    },
    recommendationTagType(state) {
      return ({ active: 'success', scheduled: 'warning', withdrawn: 'info',
        review_required: 'danger', expired: 'info' })[state] || 'info';
    },
    recommendationRecord(activity, placement) {
      return activity.recommendations?.[placement] || null;
    },
    recommendationPv(activity, placement) {
      return this.recommendationRecord(activity, placement)?.pv || 0;
    },
    formatRecommendationRange(record) {
      if (!record?.start_at || !record?.end_at) return '未配置展示时间';
      return `${this.formatTimestamp(record.start_at)} 至 ${this.formatTimestamp(record.end_at)}`;
    },
    getActivityCover(activity) {
      return activity.head_image?.url || this.getFirstPrizePic(activity.prize_config);
    },
    async openRecommendation(activity) {
      this.recommendActivity = activity;
      this.recommendPlacement = 'discovery';
      this.recommendCandidateError = '';
      this.recommendRecords = [];
      this.recommendAllLogs = [];
      this.recommendVisible = true;
      await this.loadRecommendation();
    },
    async loadRecommendation() {
      this.recommendLoading = true;
      try {
        const response = await luckdrawApi.getTaskRecommendation(this.recommendActivity.id);
        if (response.sta !== 0) throw new Error(response.msg || '加载推荐信息失败');
        this.recommendCandidateError = response.data?.candidate_error || '';
        this.recommendRecords = response.data?.records || [];
        this.recommendAllLogs = response.data?.logs || [];
        this.selectRecommendationPlacement();
      } catch (error) {
        this.recommendCandidateError = '推荐信息加载失败，请重试';
        this.$message.error(error.message || '加载推荐信息失败');
      } finally {
        this.recommendLoading = false;
      }
    },
    selectRecommendationPlacement() {
      const record = this.currentRecommendation;
      const now = new Date();
      const activityEnd = this.recommendActivity.etime
        ? new Date(this.recommendActivity.etime.replace(/-/g, '/')) : null;
      this.recommendForm = {
        start_at: record?.start_at ? new Date(record.start_at * 1000) : now,
        end_at: record?.end_at ? new Date(record.end_at * 1000) : activityEnd,
        priority: record?.priority ?? 0,
        review_note: record?.review_note || ''
      };
    },
    async saveRecommendation(action) {
      if (this.recommendSaving) return;
      const form = this.recommendForm;
      if (action === 'save' && (!form.start_at || !form.end_at || form.start_at >= form.end_at)) {
        this.$message.warning('请选择有效的推荐开始和结束时间');
        return;
      }
      this.recommendSaving = true;
      try {
        const response = await luckdrawApi.saveTaskRecommendation({
          task_id: this.recommendActivity.id,
          placement: this.recommendPlacement,
          action,
          start_at: form.start_at && Math.floor(form.start_at.getTime() / 1000),
          end_at: form.end_at && Math.floor(form.end_at.getTime() / 1000),
          priority: form.priority,
          review_note: form.review_note
        });
        if (response.sta !== 0) throw new Error(response.msg || '保存失败');
        this.$message.success(action === 'withdraw' ? '已撤下' : '推荐设置已保存');
        await this.loadRecommendation();
        this.queryData();
      } catch (error) {
        this.$message.error(error.message || '保存失败');
      } finally {
        this.recommendSaving = false;
      }
    },
    isTrialActive(expire) {
      return Number(expire) > Date.now() / 1000;
    },
    async grantActivityTrial(activity) {
      if (!activity.id || this.trialGrantingId) return;
      const activityName = this.getLotteryName(activity.name, activity.prize_config, activity.activity_topic);
      try {
        await this.$confirm(
          `为活动「${activityName}」（ID：${activity.id}）授权对接口令派发与小程序精确验证 24 小时？`,
          '确认接口试用授权',
          { confirmButtonText: '授权 24 小时', cancelButtonText: '取消', type: 'warning' }
        );
      } catch (_) {
        return;
      }

      this.trialGrantingId = activity.id;
      try {
        const res = await this.$$grantActivityOpenapiTrial({ task_id: activity.id });
        if (res && res.sta === 0 && res.data && res.data.expire) {
          activity.openapi_trial_expire = res.data.expire;
          this.$message.success(`授权成功，有效至 ${this.formatTimestamp(res.data.expire)}`);
        } else {
          this.$message.error((res && res.msg) || '授权失败，请稍后重试');
        }
      } finally {
        this.trialGrantingId = '';
      }
    },
    formatTime(pattern, value) {
      if (!value) {
        return '';
      }
      const date = new Date(value);
      const pad = (num) => String(num).padStart(2, '0');
      return pattern
        .replace('yyyy', date.getFullYear())
        .replace('MM', pad(date.getMonth() + 1))
        .replace('dd', pad(date.getDate()))
        .replace('hh', pad(date.getHours()))
        .replace('mm', pad(date.getMinutes()))
        .replace('ss', pad(date.getSeconds()));
    },
    getFirstPrizePic(prizeConfig) {
      const prizes = prizeConfig && Array.isArray(prizeConfig.prizes) ? prizeConfig.prizes : [];
      return prizes[0] && prizes[0].prize_pic ? prizes[0].prize_pic : '';
    },
    getLotteryName(name, prize_config, activity_topic) {
      if (activity_topic && activity_topic !== '幸运大抽奖') {
        return activity_topic;
      }
      const prizes = prize_config && Array.isArray(prize_config.prizes) ? prize_config.prizes : [];
      if (name) {
        return name;
      }
      if (!prizes.length) {
        return '-';
      }
      return "奖品：" + prizes.map(prize => {
        return `${prize.name} x ${prize.count}`;
      }).join('、');
    },

    getPrizeDetail(prize) {
      if (!prize.main_type) {
        return '';
      }
      return this.getMainTypeName(prize.main_type) + this.getPrizeTypeName(prize.prize_type);
    },
    getMainTypeName(main_type) {
      if (main_type === 'normal') {
        return ''
      } else if (main_type === 'discount_coupon') {
        return '(优惠券)'
      } else if (main_type === 'redemption_code') {
        return '(兑换码)'
      }
    },
    getPrizeTypeName(prize_type) {
      if (prize_type === 'express') {
        return ''
      } else if (prize_type === 'goto_store') {
        return '(到店领奖)'
      } else if (prize_type === 'jump_wxa') {
        return '(小程序领奖)'
      } else if (prize_type === 'contact_colleague') {
        return '(扫码领奖)'
      } else if (prize_type === 'empty') {
        return '(自行派奖)'
      }
    },
    onChangeDate(key) {
      if (!this[key]) {
        this.formInline[key] = {
          start: '',
          end: '',
        };
      }
    },
    onChangeVip(val) {
      this.formInline.is_vip = val ? 1 : 0
    },
    onSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      if (this.ctime && this.ctime.length) {
        this.formInline.ctime = {
          start: this.ctime[0].getTime() / 1000,
          end: this.ctime[1].getTime() / 1000 + 86399,
        };
      }
      if (this.etime && this.etime.length) {
        this.formInline.etime = {
          start: this.etime[0].getTime() / 1000,
          end: this.etime[1].getTime() / 1000 + 86399,
        };
      }
      const params = {
        page: this.currentPage,
        page_size: this.pageSize,
        ...this.formInline,
      };

      // 处理标签筛选参数
      if (this.formInline.selected_tags && this.formInline.selected_tags.length > 0) {
        params.tags = this.formInline.selected_tags.join(',');
      }

      this.loading = true;
      this.$$listActivity(
        params,
        (res) => {
          if (res.sta === 0) {
            this.loading = false;
            const data = res.data || {};
            this.tableData = Array.isArray(data.list) ? data.list : [];
            this.total = data.total || data.count || 0;
            this.tagsDict = data.tags || {};
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        },
        () => {
          this.loading = false;
          this.$message.error('请求数据失败!');
        },
      );
    },
    onReset(formName) {
      this.$refs[formName]?.resetFields();
      this.resetActivityQuery();
    },
    resetActivityQuery() {
      this.currentPage = 1;
      this.ctime = [];
      this.etime = [];
      this.formInline = createActivityFilters(this.isRecommendationPage);
      this.sort_type = -1;
      this.current_sort = {
        label: '创建时间',
        value: 'ctime',
      };
      this.queryData();
    },
    handleChangeSort(val) {
      this.currentPage = 1;
      this.formInline.sort = {
        ...this.formInline.sort,
        sort: val,
      };
      this.sort_type = val;
      this.queryData();
    },
    handleCommand(val) {
      this.currentPage = 1;
      this.current_sort = val;
      this.formInline.sort = {
        ...this.formInline.sort,
        name: val.value,
      };
      this.queryData();
    },
    handleView(record) {
      this.currentItem = record;
      this.dialogVisible = true;
    },
    toDetail(record) {
      if (record.type === 'screen') {
        this.toBackground(record.uid, record.id)
      } else {
        this.handlePreview(record.id)
      }
    },
    handlePreview(id) {
      this.$$qrcode({ id }, (res) => {
        if (res.sta === 0) {
          this.dialogQrcodeVisible = true;
          this.previewImage = res.data.promotion_wxa_qrcode_url;
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.$message.error('请求数据失败！');
      });
    },
    handleQrcodeClose() {
      this.dialogQrcodeVisible = false;
      this.previewImage = '';
    },
    handleClose() {
      this.dialogVisible = false;
      this.currentItem = {};
    },
    toBackground(uid, id) {
      this.$$getToken(
        { uid },
        (res) => {
          if (res.sta === 0) {
            // 跳转到我们爱抽奖的后台
            // eslint-disable-next-line no-restricted-globals
            const baseUrl = isTestAdminApiEnabled()
              ? `https://test-lotto.weiyoubot.cn/dashboard/create_draw/screen_draw/edit/${id}?token=`
              : `https://52choujiang.cn/dashboard/create_draw/screen_draw/edit/${id}?token=`;
            window.open(`${baseUrl + res.data.token}&gm=true`);
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error('请求数据失败！');
        },
      );
    }, // 进入后台
    setTaskBanned(id) {
      const title = `确定封禁该任务？PC暂不支持解封，要去小程序操作`;
      this.$confirm(title, '操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$$setBanned(
            { task_id: id },
            (res) => {
              if (res.sta === 0) {
                this.$message.success('封禁任务操作成功！');
                this.queryData();
              } else {
                this.$message.error(res.msg);
              }
            },
            () => {
              this.$message.error('请求数据失败！');
            },
          );
        })
        .catch(() => { });
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryData();
    },
    handleTemplate(row) {
      this.templateData = {
        type: '',
        template_title: '',
        template_img: '',
      };

      this.info = row;
      if (row.is_template) {
        let name = `「${row.name}」` || "该";
        const title = `确定要下架` + name + `模版吗？`;
        this.$confirm(title, '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.saveTemplate();
          })
          .catch(() => { });
      } else {
        this.templateVisible = true;
        this.$nextTick(() => {
          this.$refs['template_form'].resetFields();
        })
      }
    },
    saveTemplate() {
      const self = this;
      let str = '';
      if (!this.info.is_template) {
        str = '上架模板';
        this.$refs['template_form'].validate((valid) => {
          if (valid) {
            templateFunc();
          }
        });
      } else {
        str = '下架模板';
        templateFunc();
      }
      function templateFunc() {
        const data = {
          task_id: self.info.id,
          is_template: !self.info.is_template,
          type: !self.info.is_template ? self.templateData.type : '',
          template_title: self.templateData.template_title || '',
          template_img: self.templateData.template_img || '',
        };
        self.$$listActivityTemplate(data, (data) => {
          if (data.sta != 0) {
            self.$message.error({ message: data.msg ? data.msg : str + '失败!' });
          } else {
            self.$message({ type: 'success', message: str + '成功!' });
            self.templateVisible = false;
            self.queryData();
          }
        });
      }
    },
    handleImgSuccess(res) {
      if (res.sta == 0) {
        this.templateData.template_img = res.data.url;
      }
    },
    beforeImgUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    // 根据标签ID获取显示标签
    getDisplayTags(tagsData) {
      if (!tagsData || typeof tagsData !== 'object') {
        return [];
      }


      const displayTags = [];
      // 遍历所有标签分类
      for (const category in tagsData) {
        const tagIds = tagsData[category];
        if (Array.isArray(tagIds)) {
          // 对每个标签ID，查找对应的标签名称
          tagIds.forEach(tagId => {
            const tagList = this.tagsDict[category];
            if (tagList && Array.isArray(tagList)) {
              const tag = tagList.find(t => t.id === tagId);
              if (tag) {
                displayTags.push({
                  id: tagId,
                  label: tag.label,
                  category: category
                });
              }
            }
          });
        }
      }
      return displayTags;
    },
    // 根据标签分类获取对应的颜色类型
    getTagType(category) {
      const typeMap = {
        'industry': 'primary',
        'purpose': 'success'
        // 可以根据实际标签分类添加更多映射
      };
      const result = typeMap[category] || 'info';
      return result;
    },
    // 处理打标操作
    handleTagActivity(activity) {
      this.currentActivity = activity;
      this.selectedTags = [];

      // 将当前活动的标签转换为选中状态
      if (activity.tags && typeof activity.tags === 'object') {
        for (const category in activity.tags) {
          const tagIds = activity.tags[category];
          if (Array.isArray(tagIds)) {
            this.selectedTags = this.selectedTags.concat(tagIds);
          }
        }
      }

      this.tagDialogVisible = true;
    },
    // 保存标签
    saveTags() {
      if (!this.currentActivity.id) {
        this.$message.error('活动ID不存在');
        return;
      }

      // 将选中的标签按照分类重新组织
      const tagsData = {};
      for (const category in this.tagsDict) {
        const categoryTags = this.selectedTags.filter(tagId => {
          return this.tagsDict[category].some(tag => tag.id === tagId);
        });
        if (categoryTags.length > 0) {
          tagsData[category] = categoryTags;
        }
      }

      const params = {
        task_id: this.currentActivity.id,
        tags: tagsData
      };

      this.$$updateActivityTags(
        params,
        (res) => {
          if (res.sta === 0) {
            this.$message.success('标签更新成功');
            this.tagDialogVisible = false;
            // 刷新当前页数据
            this.queryData();
          } else {
            this.$message.error(res.msg || '标签更新失败');
          }
        },
        () => {
          this.$message.error('请求失败');
        }
      );
    },
    // 处理用户ID点击
    handleUserClick(userId) {
      this.currentUserInfo = {};
      this.userDialogVisible = true;
      this.userLoading = true;

      // 调用接口获取用户信息
      this.$$getLottoUserInfo(
        { uid: userId },
        (res) => {
          this.userLoading = false;
          if (res.sta === 0) {
            this.currentUserInfo = res.data;
          } else {
            this.$message.error(res.msg || '获取用户信息失败');
          }
        },
        () => {
          this.userLoading = false;
          this.$message.error('请求失败');
        }
      );
    },
    // 关闭用户信息弹窗
    handleUserDialogClose() {
      this.userDialogVisible = false;
      this.currentUserInfo = {};
    },
    formatTimestamp(val){
      return this.formatTime('yyyy-MM-dd hh:mm', val * 1000)
    },
  },
};
</script>

<style scoped>
.column-item,
.column-link-item {
  margin-bottom: 4px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0px;
  color: rgba(0, 0, 0, 0.88);
}

.column-link-item {
  color: rgba(24, 144, 255, 1);
  cursor: pointer;
}

.recommend-activity-cell {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.recommend-activity-cover {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  border-radius: 6px;
  object-fit: cover;
}

.recommend-placement-cell {
  min-height: 72px;
}

.recommend-time {
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 13px;
  line-height: 20px;
}

.recommend-meta {
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
  line-height: 18px;
}

.column-item>span:first-child {
  display: inline-block;
  min-width: 100px;
  text-align: right;
}

.head-img-box {
  display: flex;
  align-items: top;
}

.avatar-box {
  display: flex;
  align-items: center;
}

.avatar-box img {
  margin-right: 8px;
}

.filter-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.sort-icon {
  color: #475569;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;
}

.sort-icon:hover {
  color: #2563eb;
}

.el-dropdown-link {
  cursor: pointer;
}

.prize-box {
  display: flex;
  justify-content: center;
}

.prize-box img {
  width: 300px;
}

.prize-name {
  padding: 12px;
  font-family: PingFangSC-Regular;
  font-size: 17px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;
}

.prize-time {
  padding: 0 12px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: 0px;
  color: rgba(0, 0, 0, 0.65);
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 170px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 170px;
  /* height: 178px; */
  height: auto;
  display: block;
}

/* 标签样式 */
.column-item .el-tag {
  margin-right: 4px;
  margin-bottom: 4px;
}

/* 用户ID链接样式 */
.user-id-link {
  color: rgba(24, 144, 255, 1);
  cursor: pointer;
  text-decoration: underline;
}

.user-id-link:hover {
  color: rgba(64, 158, 255, 1);
}

/* 用户信息弹窗样式 */
.user-info-box {
  padding: 16px 0;
}

.info-item {
  display: flex;
  margin-bottom: 12px;
  line-height: 24px;
}

.info-item .label {
  display: inline-block;
  min-width: 120px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
}

.info-item .value {
  color: rgba(0, 0, 0, 0.88);
}

.no-data {
  text-align: center;
  padding: 40px 0;
  color: rgba(0, 0, 0, 0.45);
}
</style>
